import { isObjectEmpty } from "./appUtils";
import { PAYMENT_HOST_LIST } from "./constants";


export function showGrabPayDynamicField(paymentHostName) {
  switch (true) {
    case paymentHostName?.includes(PAYMENT_HOST_LIST.GRABPAY):
    case paymentHostName?.includes(PAYMENT_HOST_LIST.DUITNOW):
      return true;
    default:
      return false;
  }
}

export function showWorldPayDynamicField(paymentHostName) {
  switch (true) {
    case paymentHostName?.includes(PAYMENT_HOST_LIST.WORLDPAY):
      return true;
    default:
      return false;
  }
}

export function showVisInstalmentInfo(detail) {
  let state = detail.transaction_state.transaction_state;
  let type = detail.transaction_type?.transaction_type;
  let transactionInfo = detail.transaction_info;

  if (state === "REFUNDED" && type === "INSTALLMENT") {
    return false;
  } else {
    if (transactionInfo && !isObjectEmpty(detail.transaction_info)) {
      return true;
    } else {
      return false;
    }
  }
}

export function showNomuPayDynamicField(paymentHostName) {
  switch (true) {
    case paymentHostName?.includes(PAYMENT_HOST_LIST.NOMU):
      return true;
    default:
      return false;
  }
}

export function showRazerDynamicField(paymentHostName) {
    return paymentHostName?.toLowerCase().startsWith(PAYMENT_HOST_LIST.RAZER);
}

export function showFiuuDynamicField(paymentHostName) {
  return ['fiuu-direct', 'fiuu-direct-pf'].includes(paymentHostName?.toLowerCase());
}

export function showFiuuFixedFeeDynamicField(paymentHostName) {
  return [PAYMENT_HOST_LIST.FIUU_DIRECT_PF, PAYMENT_HOST_LIST.FIUU].includes(paymentHostName?.toLowerCase());
}

export function showAllinpayDynamicField(paymentHostName) {
  return paymentHostName?.toLowerCase() === PAYMENT_HOST_LIST.ALLINPAY;
}

export function resetPaymentHostRateFields(setFieldValue, index, paymentHostName) {
  const isFiuuFixedFee = showFiuuFixedFeeDynamicField(paymentHostName);
  const rateValues = {
    base_rate: "",
    markup_rate: "",
    base_rate_foreign: "",
    markup_rate_foreign: "",
    allinpay_partner_id: "",
    allinpay_base_rate_foreign: "",
    allinpay_markup_rate_foreign: "",
    allinpay_base_rate_local: "",
    allinpay_markup_rate_local: "",
    base_fix_fee_local: isFiuuFixedFee ? "0" : "",
    markup_fix_fee_local: isFiuuFixedFee ? "0" : "",
    base_fix_fee_foreign: isFiuuFixedFee ? "0" : "",
    markup_fix_fee_foreign: isFiuuFixedFee ? "0" : "",
  };

  Object.entries(rateValues).forEach(([field, value]) => {
    setFieldValue(`payment.${index}.${field}`, value);
  });
}

export function showShopbackDynamicField(paymentHostName) {
  return paymentHostName?.toLowerCase().startsWith(PAYMENT_HOST_LIST.SHOPBACK);
}

export function showNetsDynamicField(paymentHostName) {
  return paymentHostName?.toLowerCase().startsWith(PAYMENT_HOST_LIST.NETS);
}

export function showHostFiuuDynamicField(paymentHostName) {
  return [PAYMENT_HOST_LIST.FIUU].includes(paymentHostName?.toLowerCase());
}

export function showCybersourceDynamicField(paymentHostName) {
  return [PAYMENT_HOST_LIST.CYBERSOURCE].includes(paymentHostName?.toLowerCase());
}

export function showRevPayDynamicField(paymentHostName) {
  return paymentHostName?.toLowerCase().startsWith(PAYMENT_HOST_LIST.REVPAY);
}

export function showTouchNGoDynamicField(paymentHostName) {
  switch (true) {
    case paymentHostName.toLowerCase().includes(PAYMENT_HOST_LIST.TOUCHNGO):
      return true;
    default:
      return false;
  }
}

export function showDashDynamicField(paymentHostName) {
  return paymentHostName?.toLowerCase() === PAYMENT_HOST_LIST.DASH;
}

export function showAliPayDynamicField(paymentHostName) {
  return paymentHostName?.toLowerCase() === PAYMENT_HOST_LIST.ALIPAY;
}

export function showAtomeDynamicField(paymentHostName) {
  return paymentHostName?.toLowerCase() === PAYMENT_HOST_LIST.ATOME;
}
export function showWeChatDynamicField(paymentHostName) {
  return paymentHostName?.toLowerCase() === PAYMENT_HOST_LIST.WECHAT;
}
export function showShopeePayDynamicField(paymentHostName) {
  return [
    PAYMENT_HOST_LIST.SHOPEEPAY_TH,
    PAYMENT_HOST_LIST.SHOPEEPAY_SG,
    PAYMENT_HOST_LIST.SHOPEEPAY_MY,
  ].includes(paymentHostName?.toLowerCase());
}

export function showPaydeeDynamicField(paymentHostName) {
  if (typeof paymentHostName !== 'string') return false;
  switch (true) {
    case paymentHostName.toLowerCase().includes(PAYMENT_HOST_LIST.PAYDEE):
      return true;
    default:
      return false;
  }
}

export function showBSNDynamicField(paymentHostName) {
  if (typeof paymentHostName !== 'string') return false;
  switch (true) {
    case paymentHostName.toLowerCase().includes(PAYMENT_HOST_LIST.BSN):
      return true;
    default:
      return false;
  }
}

export function showDynamicField(paymentHostName, name) {
  return paymentHostName?.toString().toLowerCase().startsWith(name);
}

export function showShopeePayMYDynamicField(paymentHostName) {
  switch (true) {
    case paymentHostName.toLowerCase().includes(PAYMENT_HOST_LIST.SHOPEEPAY_MY):
      return true;
    default:
      return false;
  }
}
